// src/config.js
const isLocalhost =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

export const BASE_URL = isLocalhost ? 'http://localhost:5001/api' : '/api';

export const WS_URL =
    (window.location.protocol === 'https:' ? 'wss://' : 'ws://') +
    (isLocalhost ? 'localhost:5001' : window.location.host);